let body = document.querySelector('body');
let navbar = document.querySelector('navbar');

let body_padding = 50;
if (navbar) {
	body_padding = navbar.offsetHeight;
}
body.style.padding = `${body_padding - 10}px 0 0 0`;

